import React from 'react';
import { FaInstagram, FaGithub, FaLinkedin } from 'react-icons/fa'; // Ensure you have react-icons installed
import './NavBar.css'; // We'll create this file

export default function NavBar() {
    const handleContactClick = () => {
        window.location.href = 'mailto:asselahyazid@gmail.com?subject=Contacting You';
    };

    return (
        <nav className="navbar">
            <div className="name">YA</div>
            <div className="social-container">
                <div className="social-icons">
                    <a href="https://www.instagram.com/yazidasselah/" target="_blank" rel="noopener noreferrer">
                        <FaInstagram className="icon" />
                    </a>
                    <a href="https://github.com/Dramocrystal" target="_blank" rel="noopener noreferrer">
                        <FaGithub className="icon" />
                    </a>
                    <a href="https://www.linkedin.com/in/yazid-asselah" target="_blank" rel="noopener noreferrer">
                        <FaLinkedin className="icon" />
                    </a>
                </div>
                <button className="contact-button" onClick={handleContactClick}>Contact Me</button>
            </div>
        </nav>
    );
}

const styles = {
    nav: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem',
        backgroundColor: '#202020',
        zIndex: 1000,
    },
    name: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#63DEC7'
    },
    socialContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    socialIcons: {
        display: 'flex',
        gap: '0.5rem',
        marginRight: '10px',
    },
    icon: {
        fontSize: '1.5rem',
        color: '#fff',
    },
};
